/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

// Set true for app localized.
const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];

const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'WhigJobs',
    SITE_DESCRIPTION:
      'Search jobs in Quincy, IL and find local employment opportunities with Quincy Herald Whig. Your best source for Quincy, IL local employers.',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/whignews',
      twitter: ' https://twitter.com/WhigNews',
    },
    ASSETS: {
      logo: '/static/whigjobs/whigjobs_logo.png',
    },
    OG_IMAGE: '/static/whigjobs/whigjobs_logo.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#97bd45',
      },
    },
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-NYC7P37GB1', 'G-04SBN34ERZ'],
    BLOG_FEATURE_ACTIVE: true,
    PRICE_CONFIG: priceConfig,
  },
});
